/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Export_CsvInputs */



/**
* | output |
* | --- |
* | "Export ledger (CSV)" |
*
* @param {Promo_Export_CsvInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_export_csv = /** @type {((inputs?: Promo_Export_CsvInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Export_CsvInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter le registre (CSV)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar registro (CSV)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Exportar registro (CSV)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta registro (CSV)")
	return /** @type {LocalizedString} */ ("Export ledger (CSV)")
});